// extracted by mini-css-extract-plugin
export default {"buttons":"ModalConfirmCloseEdit_buttons__zWSTS"};